<mat-expansion-panel hideToggle expanded="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      Cuotas Transbank
    </mat-panel-title>

    <mat-panel-description>
    </mat-panel-description>
  </mat-expansion-panel-header>
  <ng-container>
    <div class="row-informativo">
      <p class="txt-informativo"><b>Transbank</b>, te ofrece la posibilidad de realizar tus ventas en <b>3 cuotas sin
          intereses</b>, sin importar el banco al que esté asociada la tarjeta de crédito de tus clientes. </p>
      <ng-container *ngIf="puedeEditar; else noPuedeEditar">
        <div class="d-flex align-items-center mb-4">
          <p class="txt-cuotas-tbk">Cuotas Transbank</p>
          <mat-slide-toggle [(ngModel)]="conCuotas" (change)="changeCuotas()" [disabled]="bloqCuotas">
          </mat-slide-toggle>
        </div>
      </ng-container>
      <ng-template #noPuedeEditar>
        <div class="d-flex align-items-center mb-4">
          <p class="txt-cuotas-tbk">Cuotas Transbank</p>
          <mat-slide-toggle [(ngModel)]="conCuotas" disabled="true"></mat-slide-toggle>
        </div>
      </ng-template>
      <div class="d-flex justify-content-end align-items-center">
        <p class="txt-link-informativo" (click)="showInfo()">¿Qué son las <b>cuotas Transbank</b>?</p>
        <i [class]="cambioFlecha" (click)="showInfo()"></i>
      </div>
    </div>
    <div class="row" *ngIf="showCuotasInfo">
      <div class="col-md-12">
        <p class="txt-cuota-info">Recuerda que al activar el <b>pago en 3 cuotas sin intereses,</b> recibirás tus abonos
          en <b>3 partes iguales.</b><br></p>
        <p class="txt-cuota-info"><i>Por ejemplo</i>, si vendes un producto de <strong>$60.000</strong> y activaste la
          venta de <strong> 3 cuotas sin intereses de Transbank</strong>, recibirás tus abonos de la siguiente forma:
        </p>
        <ul>
          <li>
            <span class="txt-cuota-info"><b>48 horas</b> después de realizada la venta recibirás <b>$20.000</b></span>
          </li>
          <li>
            <span class="txt-cuota-info"><b>30 días</b> después de realizada la venta recibirás <b>$20.000</b></span>
          </li>
          <li>
            <span class="txt-cuota-info"><b>60 días</b> después de realizada la venta recibirás <b>$20.000</b></span>
          </li>
        </ul>
        <p class="txt-cuota-info txt-cuota-info-bottom">Independiente de este beneficio, tus clientes <b>siempre podrán
            pagar en cuotas bancarias con o sin interés.</b></p>
      </div>
    </div>
  </ng-container>
</mat-expansion-panel>
